export default function TestsController(
  $q,
  editTestDialog,
  ssDialogService
) {
  const vm = this;

  vm.handleAddTest = _handleAddTest;

  function _handleAddTest($event) {
    ssDialogService.dialogs.bcp.editTestDialog = ssDialogService.alert(
      editTestDialog.getOptions($event, {
        assessmentId: vm.assessmentId,
      })
    );
    ssDialogService.show(ssDialogService.dialogs.bcp.editTestDialog);
  }
}

TestsController.$inject = [
  '$q',
  'editTestDialog',
  'ssDialogService'
];
